export default "__VITE_ASSET__19882666__"